module.exports = __webpack_public_path__ + "media/images/sandbox/peach--thumb-6a2c039e32dca139942313c847c626ae.png";